import React,{useEffect,useState} from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
// import RevSlider, { Slide, Caption } from 'react-rev-slider';
import { Link } from "react-router-dom";

import './HomeSlider.styles.css';
// import promoSlider from '../../mockups/sliderPromoProducts.json';
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';
import { Flip, Slide, toast } from 'react-toastify';
import { BASE_URL } from '../../lib/constant';

const HomeSlider = () => {

  const options = {
    margin: 5,
    responsiveClass: true,
    autoplay:true,
    nav: false,
    dots: true,
    loop: true,
    navText: ["<span></span>", "<span></span>"],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 1,
      },
      1000: {
        items: 1,

      }
    },
  };

  const [banners, setBanners] = useState([]);
  const [nbanners, setnBanners] = useState(false);
  const [items, setItems] = useState([]);

  const getBanners = async () => {
    await Axios.get('/cms/home-promo-item-banner')
    .then(function (response) {
        if (response.data) {
          if (response.data.banner.length > 0) { 
            setBanners(response.data.banner);
          }
          else {
            setBanners([]);
          }
          if (response.data.item.length > 0) { 
            response.data.item.forEach((element,i) => {
              element.expdate=element.expdate.replace("2022",`202${2+i}`);
            });
            setItems(response.data.item);
          }
          else {
            setItems([]);
          }
        }
    })
    .catch(function (error) {
      setBanners([]);
      setItems([]);
    });
};

useEffect(() => {
  getBanners();
  return () => {
    // Cleanup function
    // Cancel any outstanding network requests or subscriptions here
  };
}, [])

useEffect(() => {
  if(banners.length>0){
    if(banners.length!=nbanners.length){
      setnBanners(banners);
      setTimeout(() => {
        window.jQuery('#jtv-rev_slider').show().revolution({
          dottedOverlay: 'none',
          delay: 5000,
          startwidth: 850,
          startheight: 450,
          hideThumbs: 200,
          thumbWidth: 200,
          thumbHeight: 50,
          thumbAmount: 2,
          navigationType: 'thumb',
          navigationArrows: 'solo',
          navigationStyle: 'round',
          touchenabled: 'off',
          onHoverStop: 'off',
          swipe_velocity: 0.7,
          swipe_min_touches: 1,
          swipe_max_touches: 1,
          drag_block_vertical: true,
          spinner: 'spinner0',
          keyboardNavigation: 'off',
          navigationHAlign: 'center',
          navigationVAlign: 'bottom',
          navigationHOffset: 0,
          navigationVOffset: 20,
          soloArrowLeftHalign: 'left',
          soloArrowLeftValign: 'center',
          soloArrowLeftHOffset: 20,
          soloArrowLeftVOffset: 0,
          soloArrowRightHalign: 'right',
          soloArrowRightValign: 'center',
          soloArrowRightHOffset: 20,
          soloArrowRightVOffset: 0,
          shadow: 0,
          fullWidth: 'on',
          fullScreen: 'off',
          stopLoop: 'off',
          stopAfterLoops: -1,
          stopAtSlide: -1,
          shuffle: 'off',
          autoHeight: 'off',
          forceFullWidth: 'on',
          fullScreenAlignForce: 'off',
          minFullScreenHeight: 0,
          hideNavDelayOnMobile: 1500,
          hideThumbsOnMobile: 'off',
          hideBulletsOnMobile: 'off',
          hideArrowsOnMobile: 'off',
          hideThumbsUnderResolution: 0,
          hideSliderAtLimit: 0,
          hideCaptionAtLimit: 0,
          hideAllCaptionAtLilmit: 0,
          startWithSlide: 0,
          fullScreenOffsetContainer: ''
        });
      }, 1000);
    }
  }
},[banners])


useEffect(() => {
  if(items.length>0)window.setExpTime(items[0].expdates);
}, [items])


var RenderRevData = (data) =>{
  return (
    <>
    {data.data.length>0 && data.data.map((item, index) => {return(
      <li key={index} data-transition='slidehorizontal' data-slotamount='7' data-masterspeed='1000'
        data-slides-per-slide='1' data-thumb={item.image || 'images/slider/slide-img' + index + '.jpg'} style={{ width: "100%", height: "100%" }}><img className={'revSliderImage'} src={item.image || 'images/slider/slide-img' + index + '.jpg'} alt="slide-img"
          data-bgposition='center' data-bgfit='contain' data-bgrepeat='no-repeat'/>
      <div className="info">
        <div className='tp-caption jtv-sub-title sft slide2  tp-resizeme ' data-endspeed='500'
          data-speed='500' data-start='1100' data-easing='Linear.easeNone' data-splitin='none'
          data-splitout='none' data-elementdelay='0.1' data-endelementdelay='0.1'
          style={{ zindex: '2', maxwidth: 'auto', maxheight: 'auto', whitespace: 'nowrap', paddingRight: '0px' }}>
            <span>{item.text1}</span> </div>
            <div className='tp-caption jtv-large-title sfl  tp-resizeme' data-endspeed='500' data-speed='500'
          data-start='1300' data-easing='Linear.easeNone' data-splitin='none' data-splitout='none'
          data-elementdelay='0.1' data-endelementdelay='0.1'
          style={{ zindex: '3', maxwidth: 'auto', maxheight: 'auto', whitespace: 'nowrap' }}><span
            style={{ color: '#1e4d9d', textshadow: ' rgba(255, 255, 255, 0.8) 1px 0px 1px' }}>
            {item.text2}</span>
        </div>
        <div className='tp-caption Title sft  tp-resizeme ' data-endspeed='500' data-speed='500'
          data-start='1450' data-easing='Power2.easeInOut' data-splitin='none' data-splitout='none'
          data-elementdelay='0.1' data-endelementdelay='0.1'
          style={{ zindex: '4', maxwidth: 'auto', maxheight: 'auto', whitespace: 'nowrap', color: 'white' }}>
          {item.text3}
        </div>
        {item.url && item.url != '#' &&
        <div className='tp-caption sfb  tp-resizeme ' data-endspeed='500' data-speed='500' data-start='1500'
          data-easing='Linear.easeNone' data-splitin='none' data-splitout='none' data-elementdelay='0.1'
          data-endelementdelay='0.1' style={{ zindex: '4', maxwidth: 'auto', maxheight: 'auto', whitespace: 'nowrap', }}>
          <a href={item.url} className="jtv-shop-now-btn">Shop Now</a> </div>}
      </div>
    </li>
    )
    })}
  </>
  );
};

const addCompareList = async (matnum) => { 
  await AuthVerify.addToCompares(matnum).then((data) => {
      if(data){
          // dispatch({type:'COMPARE'});
      }
  })
}

const addToWishlist = async (matnum,wishlist) => {
  if(wishlist){
    await AuthVerify.removeFromWishlist(matnum);
  }else{
    await AuthVerify.addToWishlist(matnum);
  }
  window.setProductActiveOrNot(matnum,wishlist);
  let oldProducts=items;
  oldProducts.map(item=>{
      if(item.matnum==matnum){
          item.wishlist=!wishlist;
      }
  })
  setItems(oldProducts);
}

  return (
    <div className="jtv-slideshow">
      <Container fluid>
        <Row>
              {/* Right Side Promo Banners */}
                <Col md={items.length>0?9:12} sm={12} className={items.length>0?"col-md-push-3":""} style={{overflow: 'hidden'}}>
                  <div id='jtv-rev_slider_wrapper' className='rev_slider_wrapper fullwidthbanner-container'>
                    <div id='jtv-rev_slider' className='rev_slider fullwidthabanner'>
                    <ul>
                      <RenderRevData data={nbanners}/>
                      {/* {nbanners && nbanners.map((item, index) => {
                        return( 
                        <li data-transition='fade' data-delay="5000" data-slotamount='7' data-masterspeed='1000' data-slides-per-slide='1' 
                          data-thumb={item.image}><img src={item.image} alt="slide-img"
                            data-bgposition='left top' data-bgfit='cover' data-bgrepeat='no-repeat' />
                          <div className="info">
                            <div className='tp-caption jtv-sub-title sft slide2  tp-resizeme ' data-endspeed='500'
                              data-speed='500' data-start='1100' data-easing='Linear.easeNone' data-splitin='none'
                              data-splitout='none' data-elementdelay='0.1' data-endelementdelay='0.1'
                              style={{ zindex: '2', maxwidth: 'auto', maxheight: 'auto', whitespace: 'nowrap', paddingRight: '0px' }}>
                                <span>{item.text1}</span> </div>
                            <div className='tp-caption jtv-large-title sfl  tp-resizeme ' data-endspeed='500' data-speed='500'
                              data-start='1300' data-easing='Linear.easeNone' data-splitin='none' data-splitout='none'
                              data-elementdelay='0.1' data-endelementdelay='0.1'
                              style={{ zindex: '3', maxwidth: 'auto', maxheight: 'auto', whitespace: 'nowrap', }}>new trends</div>
                            <div className='tp-caption Title sft  tp-resizeme ' data-endspeed='500' data-speed='500'
                              data-start='1500' data-easing='Power2.easeInOut' data-splitin='none' data-splitout='none'
                              data-elementdelay='0.1' data-endelementdelay='0.1'
                              style={{ zindex: '4', maxwidth: 'auto', maxheight: 'auto', whitespace: 'nowrap' }}>
                                {item.text2}</div>
                            <div className='tp-caption sfb  tp-resizeme ' data-endspeed='500' data-speed='500' data-start='1500'
                              data-easing='Linear.easeNone' data-splitin='none' data-splitout='none' data-elementdelay='0.1'
                              data-endelementdelay='0.1' style={{ zindex: '4', maxwidth: 'auto', maxheight: 'auto', whitespace: 'nowrap' }}>
                              <a href='#' className="jtv-shop-now-btn">{item.text3}</a> </div>
                          </div>
                        </li>
                      )})} */}
                    </ul>
                    </div>
                  </div>
                </Col>

              {/*Left Side Promo Slider  */}
              {items.length>0 &&
                < Col md={3} sm={5} className="hot-deal col-md-pull-9">
                  <div className="slider-items-products">
                    <div className="slider-items slider-width-col4">
                      <OwlCarousel id="related-products-slider" className="product-flexslider hidden-buttons owl-theme" {...options}>
                        {items && items?.map((data,i) => (
                          <div className="item" key={i}>
                            <input type="hidden" className={'related-products-slider-value'} value={data.expdate}/>
                            <div className="item-inner">
                              <div className="item-img">
                                <div className="item-img-info"> 
                                  <Link className="product-image" title={data.matname} to={"/product-detail?matnum="+data?.matnum}>
                                    <img src={AuthVerify.getImageLink(data?.imageurl)} alt={data.matname} height="252px"/>
                                  </Link>
                                  {data?.discount && <div className="hot-label hot-top-left">{(data?.discount || '0' )+ "% off"}</div>}
                                  <div className="jtv-box-hover">
                                    <ul className="add-to-links">
                                      <li><a className="link-quickview" href="#"><i
                                        className="icon-magnifier-add icons"></i><span className="hidden">Quick View</span></a></li>
                                      <li><button className={`link-wishlist matnum-${data?.matnum} ${data.wishlist?'active':''}`} onClick={()=>addToWishlist(data?.matnum, data.wishlist)} style={{background:"none",border:"none"}}><i className="icon-heart icons"></i><span
                                        className="hidden">Wishlist</span></button></li>
                                      <li><button className="link-compare" onClick={()=>addCompareList(data?.matnum)} style={{background:"none",border:"none"}}><i className="icon-shuffle icons"></i><span
                                        className="hidden">Compare</span></button></li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="item-info">
                                <div className="info-inner">
                                  <div className="item-title"> 
                                    <Link title={data.matname} to={"/product-detail?matnum="+data?.matnum}>
                                      {data?.matname}
                                    </Link>
                                  </div>
                                  <div className="item-content">
                                    <div className="rating"> <i className="fa fa-star"></i> <i className="fa fa-star"></i> <i
                                      className="fa fa-star-o"></i> <i className="fa fa-star-o"></i> <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="item-price">
                                      <div className="price-box"> <span className="regular-price"> <span className="price">
                                        {`S$${data?.sellingprice} (w/GST S$${data?.gstprice})`}
                                        <br/>
                                        <span style={{color:'grey',textDecoration:'line-through', fontSize:'14px'}} className="price">U.P. S${data.usualprice}</span>
                                      </span> </span> </div>
                                    </div>
                                    <div className="action">
                                      <button data-original-title="Add to Cart" title="" type="button"
                                        className="button btn-cart" onClick={()=>AuthVerify.addTocart(data)}><span>Add to Cart</span> </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="jtv-box-timer">
                                  <div className="countbox_1 timer-grid"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                        {/* <div className="item">
                    <div className="item-inner">
                      <div className="item-img">
                        <div className="item-img-info"> <a href="#" title="Product Title Here" className="product-image"> <img
                          src="images/products/img01.jpg" alt="Product Title Here" /></a>
                          <div className="hot-label hot-top-left" >45% off</div>
                          <div className="jtv-box-hover">
                            <ul className="add-to-links">
                              <li><a className="link-quickview" href="#"><i
                                className="icon-magnifier-add icons"></i><span className="hidden">Quick View</span></a></li>
                              <li><a className="link-wishlist" href="wishlist.html"><i className="icon-heart icons"></i><span
                                className="hidden">Wishlist</span></a></li>
                              <li><a className="link-compare" href="compare.html"><i className="icon-shuffle icons"></i><span
                                className="hidden">Compare</span></a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="item-info">
                        <div className="info-inner">
                          <div className="item-title"> <a href="#" title="Product Title Here"> Staedtler
                            Pencil Lumograph Set + One Eraser, Sharpener</a></div>
                          <div className="item-content">
                            <div className="rating"> <i className="fa fa-star"></i> <i className="fa fa-star"></i> <i
                              className="fa fa-star-o"></i> <i className="fa fa-star-o"></i> <i className="fa fa-star-o"></i>
                            </div>
                            <div className="item-price">
                              <div className="price-box"> <span className="regular-price"> <span className="price">S$8.11 (w/GST
                                S$8.68)</span> </span> </div>
                            </div>
                            <div className="action">
                              <button data-original-title="Add to Cart" title="" type="button"
                                className="button btn-cart"><span>Add to Cart</span> </button>
                            </div>
                          </div>
                        </div>
                        <div className="jtv-box-timer">
                          <div className="countbox_1 timer-grid"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="item-inner">
                      <div className="item-img">
                        <div className="item-img-info"> <a href="#" title="Product Title Here" className="product-image"> <img
                          src="images/products/img01.jpg" alt="Product Title Here" /></a>
                          <div className="hot-label hot-top-left">25% off</div>
                          <div className="jtv-box-hover">
                            <ul className="add-to-links">
                              <li><a className="link-quickview" href="#"><i
                                className="icon-magnifier-add icons"></i><span className="hidden">Quick View</span></a></li>
                              <li><a className="link-wishlist" href="wishlist.html"><i className="icon-heart icons"></i><span
                                className="hidden">Wishlist</span></a></li>
                              <li><a className="link-compare" href="compare.html"><i className="icon-shuffle icons"></i><span
                                className="hidden">Compare</span></a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="item-info">
                        <div className="info-inner">
                          <div className="item-title"> <a href="#" title="Product Title Here"> Staedtler
                            Pencil Lumograph Set + One Eraser, Sharpener</a></div>
                          <div className="item-content">
                            <div className="rating"> <i className="fa fa-star"></i> <i className="fa fa-star"></i> <i
                              className="fa fa-star-o"></i> <i className="fa fa-star-o"></i> <i className="fa fa-star-o"></i>
                            </div>
                            <div className="item-price">
                              <div className="price-box"> <span className="regular-price"> <span className="price">S$8.11 (w/GST
                                S$8.68)</span> </span> </div>
                            </div>
                            <div className="action">
                              <button data-original-title="Add to Cart" title="" type="button"
                                className="button btn-cart"><span>Add to Cart</span> </button>
                            </div>
                          </div>
                        </div>
                        <div className="jtv-box-timer">
                          <div className="countbox_1 timer-grid"></div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                      </OwlCarousel>
                    </div>
                  </div>
                </Col>
              }
        </Row>
      </Container>
    </div >
  );
};

export default HomeSlider;
